import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from "@/integrations/supabase/client";

export const AuthHashHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthHash = async () => {
      const hash = window.location.hash;
      if (!hash) return;

      // Parse the hash for auth tokens
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      const refreshToken = params.get('refresh_token');
      const type = params.get('type');

      if (accessToken && refreshToken && type) {
        try {
          // Set the session with the tokens from the URL
          const { data, error } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });

          if (error) {
            console.error('Error setting session from URL hash:', error);
            return;
          }

          // Clean the URL hash
          window.history.replaceState(null, '', window.location.pathname);

          // Check if this user needs to set their password
          if (data.session?.user) {
            const userId = data.session.user.id;
            
            // Check if password is set for this user
            const { data: profile } = await supabase
              .from('profiles')
              .select('password_set')
              .eq('user_id', userId)
              .single();

            if (profile && profile.password_set === false) {
              console.log('🔐 User needs to set password, redirecting to /set-password');
              navigate('/set-password');
              return;
            }

            // Normal flow - redirect to dashboard
            navigate('/dashboard');
          }
        } catch (error) {
          console.error('Error processing auth hash:', error);
          window.history.replaceState(null, '', window.location.pathname);
        }
      }
    };

    handleAuthHash();
  }, [navigate]);

  return null;
};